import React, { useState } from 'react';
import { makeRequestAuth } from '../../_config/api';
import { toast } from 'react-toastify';

export default function ManualAssignModal({ isOpen, onClose, allPlans }) {
    const [phone, setPhone] = useState('');
    const [users, setUsers] = useState([]);
    const [selectedUser, setSelectedUser] = useState(null);

    const [planId, setPlanId] = useState('');
    const [paymentMethod, setPaymentMethod] = useState('Cash');
    const [remarks, setRemarks] = useState('');
    const [loading, setLoading] = useState(false);

    const handleSearch = async () => {
        if (!phone) return toast.error("Phone number enter karein");
        try {
            const res = await makeRequestAuth('post', '/admin/searchUserByPhone', { phone });
            if (!res.error) {
                setUsers(res.data);
            }
        } catch (err) {
            toast.error("User search failed");
        }
    };

    const handleAssign = async () => {
        if (!selectedUser || !planId) return toast.error("User aur Plan select karein");

        setLoading(true);
        try {
            const payload = {
                userId: selectedUser._id,
                planId: planId,
                paymentMethod: paymentMethod,
                remarks: remarks
            };

            const res = await makeRequestAuth('post', '/admin/assignManualSubscription', payload);
            if (!res.error) {
                toast.success("Plan Successfully Assigned! Vouchers Added.");
                onClose();
            } else {
                toast.error(res.message || "Failed to assign");
            }
        } catch (err) {
            toast.error("Assignment failed");
        } finally {
            setLoading(false);
        }
    };

    if (!isOpen) return null;

    return (
        <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50">
            <div className="bg-white p-6 rounded-2xl w-[500px] shadow-2xl">
                <h2 className="text-xl font-bold mb-4">Manual Plan Assignment</h2>

                {/* Search User */}
                <div className="flex gap-2 mb-4">
                    <input
                        type="text"
                        placeholder="Search by Phone Number"
                        className="border p-2 rounded-lg w-full"
                        value={phone} onChange={(e) => setPhone(e.target.value)}
                    />
                    <button onClick={handleSearch} className="bg-blue-600 text-white px-4 py-2 rounded-lg">Search</button>
                </div>

                {/* User Selection List */}
                {users && users.length > 0 && (
                    <div className="mb-4 max-h-32 overflow-y-auto border rounded-lg p-2 bg-gray-50">
                        {users.map(u => (
                            <div
                                key={u._id}
                                onClick={() => setSelectedUser(u)}
                                className={`p-2 cursor-pointer hover:bg-blue-100 rounded ${selectedUser?._id === u._id ? 'bg-blue-100 border border-blue-500' : ''}`}
                            >
                                <p className="font-semibold">{u.name}</p>
                                <p className="text-sm text-gray-600">{u.phone}</p>
                            </div>
                        ))}
                    </div>
                )}

                {/* Selected User Display */}
                {selectedUser && (
                    <div className="space-y-4">
                        <div className="p-3 bg-green-50 border border-green-200 rounded-lg">
                            <span className="text-green-700 font-bold">Selected:</span> {selectedUser.name} ({selectedUser.phone})
                        </div>

                        {/* Select Plan */}
                        <select
                            className="w-full border p-2 rounded-lg"
                            value={planId}
                            onChange={(e) => setPlanId(e.target.value)}
                        >
                            <option value="">Select Plan...</option>
                            {allPlans?.map(p => (
                                <option key={p._id} value={p._id}>{p.name} - ₹{p.price}</option>
                            ))}
                        </select>

                        {/* Payment Details */}
                        <select
                            className="w-full border p-2 rounded-lg"
                            value={paymentMethod}
                            onChange={(e) => setPaymentMethod(e.target.value)}
                        >
                            <option value="Cash">Paid via Cash</option>
                            <option value="UPI">Paid via UPI / QR</option>
                            <option value="Bank Transfer">Bank Transfer</option>
                            <option value="Complimentary">Complimentary / Free</option>
                        </select>

                        <input
                            type="text"
                            placeholder="Transaction ID / Remarks (Optional)"
                            className="w-full border p-2 rounded-lg"
                            value={remarks} onChange={(e) => setRemarks(e.target.value)}
                        />

                        {/* Submit Button */}
                        <button
                            onClick={handleAssign}
                            disabled={loading}
                            className="w-full bg-slate-900 text-white font-bold py-3 rounded-lg hover:bg-slate-800 transition"
                        >
                            {loading ? "Assigning..." : "Assign Plan"}
                        </button>
                    </div>
                )}

                <button onClick={onClose} className="mt-4 text-gray-500 hover:text-red-600 w-full text-center">Cancel & Close</button>
            </div>
        </div>
    );
}
